import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { AlgoStrategyLookupService } from "./AlgoStrategyLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";
import { IAlgoStrategyPromiseLookupService } from "../IAlgoStrategyPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import { CubiqWorker } from "../../../worker/CubiqWorker";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class AlgoStrategyPrimaryLookupService
  extends PrimaryLookupService<string, CubiqTS.AlgoStrategyImpl>
  implements IAlgoStrategyPromiseLookupService
{
  constructor(
    protected base: AlgoStrategyLookupService,
    protected factory: ServiceMessageBrokerFactory,
    protected cubiqWorker: CubiqWorker,
  ) {
    super(base, factory, CubiqTS.AlgoStrategyImpl, cubiqWorker, "AlgoStrategyImpl");

    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let rateSourceObservable = cubiqWorker.primeStaticData<CubiqTS.AlgoStrategyImpl>(
          CubiqTS.AlgoStrategyImpl.name,
        );

        rateSourceObservable.subscribe(
          (rateSource: CubiqTS.AlgoStrategyImpl[]) => {
            this.base.prime(rateSource);
          },
          (error: Error) => {
            console.debug("AlgoStrategy prime failed");
            this._primed.reject(error);
          },
          () => {
            this._primed.resolve(true);
          },
        );
      },
      (reason) => {
        console.debug("AlgoStrategyPrimaryLookupService: Failed to prime: " + reason);

        this._primed.resolve(false);
      },
    );

    this.broker.registerMethod(
      "getAlgoStrategy",
      [PRIMITIVE],
      this.getAlgoStrategy.bind(this),
      this.VALUE,
    );
    this.broker.registerMethod("getAllIds", [PRIMITIVE], this.getAllIds.bind(this), PRIMITIVE);
  }

  getAlgoStrategy(id: string): Promise<CubiqTS.AlgoStrategyImpl> {
    return new Promise<CubiqTS.AlgoStrategyImpl>((res, rej) => {
      res(this.base.getAlgoStrategy(id));
    });
  }

  getAllIds(): Promise<Array<string>> {
    return new Promise<Array<string>>((res, rej) => {
      res(this.base.getAllAlgoStrategyIds());
    });
  }
}
